var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.455,
    height: 35.455,
    viewBox: "0 0 35.455 35.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(-320.023 -1775.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 17.728,
    cy: 17.728,
    r: 17.728,
    transform: "translate(320.023 1775.397)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_636",
    "data-name": "Line 636",
    x1: 15.158,
    y2: 13.461,
    transform: "translate(331.301 1786.394)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_637",
    "data-name": "Line 637",
    x2: 15.158,
    y2: 13.461,
    transform: "translate(331.301 1786.394)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.62
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShow);
export default __webpack_public_path__ + "static/media/icon-show.8d8a72fe33fa5e68e4fec16207a46ef5.svg";
export { ForwardRef as ReactComponent };